import React, { useEffect, useState } from 'react'

import MiTabla from '../../../components/plantilla/tabla/MiTabla'
import { Box } from '@mui/material'
import { myApi } from '../../../config/axiosConfig'
const moment = require("moment");

function DashboardDiesel() {

  const [data, setData] = useState([]);

  const columns = [
    { field: "fechaHora", headerName: "Fecha y Hora", flex: 1, headerAlign: "center", align: "center" },
    { field: "unidad", headerName: "Unidad", flex: 1, headerAlign: "center", align: "center" },
    { field: "odometroCamion", headerName: "Odometro de la camión", flex: 1, headerAlign: "center", align: "center" },
    { field: "horasDelMotorDelRemolque", headerName: "Horas del motor del remolque", flex: 1, headerAlign: "center", align: "center" },
    { field: "tipo", headerName: "Tipo", flex: 1, headerAlign: "center", align: "center" },
    { field: "transportista", headerName: "Transportista", flex: 1, headerAlign: "center", align: "center" },
    { field: "operador", headerName: "Operador", flex: 1, headerAlign: "center", align: "center" },
    { field: "cantidadGalones", headerName: "Cantidad de Galones", flex: 1, headerAlign: "center", align: "center" },
    { field: "precioPorGalon", headerName: "Precio por galón", flex: 1, headerAlign: "center", align: "center" },
    { field: "precioTotal", headerName: "Precio Total", flex: 1, headerAlign: "center", align: "center" },
    { field: "noOrden", headerName: "No. Orden", flex: 1, headerAlign: "center", align: "center" },
    { field: "personaCombustible", headerName: "Persona que cargo combustible", flex: 1, headerAlign: "center", align: "center" },
    { field: "tipoOrden", headerName: "Tipo de orden", flex: 1, headerAlign: "center", align: "center" },
    { field: "odometroTanque", headerName: "Odometro del tanque", flex: 1, headerAlign: "center", align: "center" },
  ];

  useEffect(() => {
    obtenerDatos();
  }, []);

  const obtenerDatos = async () => {
    try {
      const response = await myApi.get("/fuel_up/vista/dashboard");
      const { tractores, remolques } = response.data;
      console.log(tractores, remolques);
      const datosTrasformados = transformarDatos(tractores, remolques);
      setData(datosTrasformados);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  };

  const transformarDatos = (tractores, remolques) => {
    const tractoresData = tractores.data.map((tractor) => ({
      id: tractor.id,
      fechaHora: moment(tractor.date).format("DD-MM-YYYY"),
      unidad: tractor.vehicleNumber,
      odometroCamion: tractor.odometerNumber,
      horasDelMotorDelRemolque: "-", // No aplica para tractores
      tipo: tractor.tractorType,
      transportista: tractor.carrier,
      operador: tractor.operatorName,
      cantidadGalones: tractor.fuelLoaded,
      precioPorGalon: "-", // Agregar el dato si está disponible
      precioTotal: "-", // Agregar el dato si está disponible
      noOrden: "-", // Agregar el dato si está disponible
      personaCombustible: "-", // Agregar el dato si está disponible
      tipoOrden: "Tractor", // Diferenciar tractores de remolques
      odometroTanque: tractor.odometerBomb,
    }));

    const remolquesData = remolques.data.map((remolque) => ({
      id: remolque.id,
      fechaHora: moment(remolque.date).format("DD-MM-YYYY"),
      unidad: remolque.vehicleNumber,
      odometroCamion: "-", // No aplica para remolques
      horasDelMotorDelRemolque: remolque.reeferHours,
      tipo: remolque.operationType,
      transportista: remolque.carrier,
      operador: remolque.operatorName,
      cantidadGalones: remolque.fuelLoaded,
      precioPorGalon: "-", // Agregar el dato si está disponible
      precioTotal: "-", // Agregar el dato si está disponible
      noOrden: remolque.orderNumber,
      personaCombustible: "-", // Agregar el dato si está disponible
      tipoOrden: remolque.operationType,
      odometroTanque: remolque.odometerBomb,
    }));

    return [...tractoresData, ...remolquesData];
  };
  return (
    <Box sx={{ p: 2 }}>
      <MiTabla
        columns={columns}
        data={data}
      />
    </Box>
  )
}

export default DashboardDiesel